<template>
  <div>
    <v-container>
      <div class="text-xs-right">
        <v-btn outline color="green" @click="showAddModal">
          <em class="fas fa-plus mr-2" />Add Appointment</v-btn
        >
        <v-btn outline color="orange" @click="exportAppointment">
          <em class="fas fa-file-import mr-2" />Export</v-btn
        >
        <!-- <v-btn outline color="grey"> <v-icon>search</v-icon>Search</v-btn> -->
      </div>
      <div>
        <date-filter v-model="selectedDate" @changeDate="setData"></date-filter>
      </div>

      <div>
        <v-layout wrap>
          <v-flex xs12 sm3 class="form-control pa-1">
            <input
              v-model="filter.customer"
              type="text"
              placeholder="Name/Account No."
              @input="onSearch"
            />
          </v-flex>
          <v-flex xs12 sm3 class="form-control pa-1">
            <multiselect
              v-model="filter.service"
              :data-vv-as="$t('Service')"
              name="Service"
              :placeholder="'Service'"
              :options="servicelist"
              select-label
              selected-label
              deselect-label
              group-values="service"
              group-label="category"
              :group-select="false"
              @input="setData"
            ></multiselect>
          </v-flex>
          <v-flex xs12 sm3 class="pa-1">
            <multiselect
              v-model="filter.status"
              :data-vv-as="$t('Status')"
              name="Status"
              :placeholder="'Status'"
              :options="[
                '',
                'Pending',
                'Approved',
                'Done',
                'Cancel By Customer',
                'Cancel By Admin'
              ]"
              select-label
              selected-label
              deselect-label
              @input="setData"
            ></multiselect>
          </v-flex>
        </v-layout>
      </div>
      <template v-if="summary">
        <v-layout>
          <v-flex style="font-weight: 600"
            >Approved<br /><span style="color: pink; font-size: 23px">{{
              summary.approved
            }}</span></v-flex
          >
          <v-flex style="font-weight: 600"
            >Pending<br /><span style="color: pink; font-size: 23px">{{
              summary.pending
            }}</span></v-flex
          >
          <v-flex style="font-weight: 600"
            >Cancel<br /><span style="color: pink; font-size: 23px">{{
              summary.cancel
            }}</span></v-flex
          >
          <v-flex style="font-weight: 600"
            >Done<br /><span style="color: pink; font-size: 23px">{{ summary.done }}</span></v-flex
          >
          <v-flex style="font-weight: 600"
            >Total<br /><span style="color: pink; font-size: 23px">{{ data.length }}</span></v-flex
          >
        </v-layout>
      </template>
      <!-- <div style="font-weight: 600" class="text-xs-right">
        Total: <span style="color: pink; font-size: 23px">{{ filterAppointments.length }}</span>
      </div> -->
      <v-data-table
        :headers="headers"
        :items="data"
        class="elevation-1"
        :pagination.sync="pagination"
        :loading="loading"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template #items="props">
          <tr :key="props.item.id">
            <td class="text-xs-right">
              <div style="white-space: nowrap">
                <v-btn icon small @click="showEditModal(props.item)">
                  <v-icon color="grey">edit</v-icon>
                </v-btn>
              </div>
            </td>
            <td>{{ props.item.id }}</td>
            <td class="text-xs-left">{{ props.item.custumer_name_en }}</td>
            <td class="text-xs-left">
              {{ props.item.appointment_date | DateFormat('DD/MM/YYYY') }}
            </td>
            <td class="text-xs-left">
              {{ props.item.appointment_time_from }} - {{ props.item.appointment_time_to }}
            </td>
            <td class="text-xs-left">
              {{ props.item.project_name }}
            </td>
            <td class="text-xs-left">{{ props.item.unit_no }}</td>
            <td class="text-xs-left py-2">
              {{ props.item.service }}
              <!-- <v-select
              :data-vv-as="$t('Service')"
              name="Service"
              :placeholder="'Service'"
              v-model="props.item.service"
              outline
              single-line
              :items="services"
              hide-details
              @input="onChangeValue(props.item, $event)"
            ></v-select> -->
            </td>
            <td class="text-xs-center py-2">
              {{ props.item.status }}
              <!-- <v-select
              :data-vv-as="$t('Status')"
              name="Status"
              :placeholder="'Status'"
              v-model="props.item.status"
              outline
              single-line
              :items="['', 'Pending', 'Approved', 'Done', 'Cancel By Customer', 'Cancel By Admin']"
              hide-details
              @input="onChangeValue(props.item, $event)"
            ></v-select> -->
            </td>
            <td class="text-xs-center">{{ props.item.point }}</td>
            <td class="text-xs-center">{{ props.item.admin ? props.item.admin : '-' }}</td>
            <td class="text-xs-center">
              {{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
            </td>
            <td class="text-xs-right">
              <div style="white-space: nowrap">
                <v-btn icon small @click="deleteAppointment(props.item)">
                  <v-icon color="grey">delete</v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
    <div>
      <v-dialog v-model="showEdit" width="650px" min-height="500px" persistent>
        <v-card min-height="500px" style="min-height: 500px">
          <EditAppointment
            v-if="showEdit"
            :customers="customers"
            :services="services"
            :type="edittype"
            :editdata="editdata"
            @close="showEdit = false"
            @saveAppointment="saveAppointment"
          ></EditAppointment>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import EditAppointment from './EditAppointment.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import * as XLSX from 'xlsx'
export default {
  components: {
    EditAppointment,
    DateFilter,
    Multiselect
  },
  data() {
    return {
      pagination: {
        sortBy: 'timestamp',
        descending: true,
        rowsPerPage: 20
      },
      rowsPerPageItems: [10, 20, 30, 40],
      // summary: { approved: 0, pending: 0, cancel: 0 },
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm'),
        end: moment().format('YYYY-MM-DD HH:mm')
      },
      edittype: '',
      editdata: {},
      customers: [],
      showEdit: false,
      headers: [
        { text: '', value: '', sortable: false },
        { text: 'ID', value: 'id' },
        { text: 'Customer name', value: 'custumer_name_en' },
        { text: 'Appointment Date', value: 'appointment_date' },
        { text: 'Appointment Time', sortable: false },
        { text: 'ชื่อคอนโด', value: 'project_name' },
        { text: 'บ้านเลขที่', value: 'unit_no' },
        { text: 'Service', value: 'service' },
        { text: 'Status', value: 'status' },
        { text: 'Point', value: 'point' },
        { text: 'Admin', value: 'admin' },
        { text: 'Timestamp', value: 'timestamp' },
        { text: '', value: '', sortable: false }
      ],
      data: [],
      filter: {
        customer: '',
        service: '',
        status: '',
        search: ''
      },
      services: [],
      timestamp: moment().format('x'),
      loading: true,
      searchAppointmentTimeout: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    // filterAppointments() {
    //   if (this.filter) {
    //     return this.data
    //       .filter((el) => {
    //         var search = true
    //         if (this.filter.customer && this.filter.customer.trim() != '') {
    //           search =
    //             search &&
    //             ((el.custumer_name_th &&
    //               el.custumer_name_th.toLowerCase().includes(this.filter.customer.toLowerCase())) ||
    //               (el.custumer_name_en &&
    //                 el.custumer_name_en.toLowerCase().includes(this.filter.customer.toLowerCase())))
    //         }
    //         if (this.filter.service && this.filter.service.trim() != '') {
    //           search =
    //             search &&
    //             el.service &&
    //             el.service.toLowerCase().includes(this.filter.service.toLowerCase())
    //         }
    //         if (this.filter.status && this.filter.status.trim() != '') {
    //           search =
    //             search &&
    //             el.status &&
    //             el.status.toLowerCase().includes(this.filter.status.toLowerCase())
    //         }
    //         return search
    //       })
    //       .map((el, index) => {
    //         return {
    //           ...el,
    //           index: index
    //         }
    //       })
    //   }
    //   return this.data.map((el, index) => {
    //     return {
    //       ...el,
    //       index: index
    //     }
    //   })
    // },
    servicelist() {
      try {
        return this.services
          .filter((el) => {
            return el != null && el != ''
          })
          .reduce((prev, curr) => {
            var index = prev.findIndex((el) => {
              return el.category == curr.category_service
            })
            if (index != -1) {
              prev[index].service.push(curr.service)
            } else {
              prev.push({
                category: curr.category_service,
                service: [curr.service]
              })
            }
            return prev
          }, [])
      } catch (error) {}
      return []
    },
    summary() {
      return this.data.reduce(
        (prev, curr) => {
          if (curr.status.toLowerCase().includes('cancel')) {
            prev['cancel']++
          } else prev[curr.status.toLowerCase()]++
          return prev
        },
        {
          approved: 0,
          pending: 0,
          cancel: 0,
          done: 0
        }
      )
    }
  },

  async mounted() {
    this.loading = true
    await this.getCustomer()
    var service_response = await this.getmjdappointmentchangeservice()
    var services = service_response.data
    this.services = ['', ...services]
    var response = await this.getData()
    if (response.data.length > 0) {
      // this.summary = {
      //   approved: response.data[0].approved,
      //   pending: response.data[0].pending,
      //   cancel: response.data[0].calcel
      // }
    }
    this.data = response.data2
    this.loading = false
  },
  methods: {
    onSearch() {
      const vm = this
      if (vm.searchAppointmentTimeout) {
        clearTimeout(vm.searchAppointmentTimeout)
      }
      vm.searchAppointmentTimeout = setTimeout(async () => {
        await this.setData()
        vm.searchAppointmentTimeout = null
      }, 1000)
    },
    async setData() {
      this.loading = true
      try {
        const response = await this.getData()
        this.data = response.data2
        this.loading = false
        return true
      } catch (error) {
        console.error(error)
        this.loading = false
        return false
      }
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index == 'index') {
          if (!isDesc[0]) {
            return b[index] - a[index]
          } else {
            return a[index] - b[index]
          }
        } else if (index == 'date') {
          if (!isDesc[0]) {
            return new Date(b[index]) - new Date(a[index])
          } else {
            return new Date(a[index]) - new Date(b[index])
          }
        } else {
          if (typeof a[index] !== 'undefined') {
            if (!isDesc[0]) {
              return a[index].toLowerCase().localeCompare(b[index].toLowerCase())
            } else {
              return b[index].toLowerCase().localeCompare(a[index].toLowerCase())
            }
          }
        }
      })
      return items
    },
    async onChangeValue(item, val) {
      console.log(item, val)
      try {
        var data = {
          ...item,
          pageid: this.selectedBot.pageid
        }
        await this.putmjdappointmentchangedByadmin(data)
        var index = this.data.findIndex((el) => {
          return el.id == data.id
        })

        if (index != -1) this.$set(this.data, index, data)
      } catch (error) {}
    },
    async saveAppointment({ appointment, oncomplete }) {
      try {
        var data = {
          ...appointment,
          pageid: this.selectedBot.pageid,
          appointment_date: appointment.appointment_date
            ? moment(appointment.appointment_date).format('YYYY-MM-DD')
            : ''
        }
        if (this.edittype == 'add') {
          var response = await this.postmjdadmincreateappointment(data)
          if (response.data && response.data.length > 0) {
            this.data.push(response.data[0])
          }
        } else if (this.edittype == 'edit') {
          await this.putmjdappointmentchangedByadmin(data)
          var index = this.data.findIndex((el) => {
            return el.id == data.id
          })

          if (index != -1) this.$set(this.data, index, data)
        }
        await this.$swal.fire({
          type: 'success',
          text: 'สำเร็จ'
        })
        this.timestamp = moment().format('x')
        this.showEdit = false
      } catch (error) {}
      if (oncomplete) {
        oncomplete()
      }
    },
    postmjdadmincreateappointment(data) {
      return new Promise((resolve, reject) => {
        api.postmjdadmincreateappointment(data, (err, response) => {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      })
    },
    putmjdappointmentchangedByadmin(data) {
      return new Promise((resolve, reject) => {
        api.putmjdappointmentchangedByadmin(data, (err, response) => {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      })
    },
    getmjdappointmentchangeservice(account_no) {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getmjdappointmentchangeservice(
          { pageid: vm.selectedBot.pageid, account_no: account_no },
          (err, response) => {
            if (err || response.responsecode != 200) reject(err)
            resolve(response)
          }
        )
      })
    },
    async deleteAppointment(appointment) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        api.deletemjdappointmentdeleteByadmin(
          {
            pageid: this.selectedBot.pageid,
            id: appointment.id
          },
          (err, response) => {
            if (err || response.responsecode != 200) {
              return false
            }
            var index = this.data.findIndex((el) => {
              return el.id == appointment.id
            })
            if (index != -1) this.data.splice(index, 1)
          }
        )
      }
    },
    exportAppointment() {
      var json = this.data.map((el) => {
        return {
          'Appointment id': el.id,
          'Customer name': el.custumer_name ? el.custumer_name : el.custumer_name_en,
          'Customer name TH': el.custumer_name_th,
          Email: el.email,
          'Phone No.': el.phone_number,
          'Appointment Date': el.appointment_date
            ? moment(el.appointment_date).format('DD/MM/YYYY')
            : '-',
          'Appointment Time': el.appointment_time_from + ' - ' + el.appointment_time_to,
          ชื่อคอนโด: el.project_name,
          บ้านเลขที่: el.unit_no,
          Service: el.service,
          Status: el.status,
          Point: el.point,
          Admin: el.admin ? el.admin : '-',
          Remark: el.remark
        }
      })

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'mjd-appointments.xlsx')
    },
    getCustomer() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve) => {
        api.getmjdcustomerdashboard(data, (err, response) => {
          if (response.responsecode == 200) {
            this.customers = response.data
          }
          resolve()
        })
      })
    },
    getData() {
      return new Promise((resolve, reject) => {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'), // YYYY-MM-DD
          service: this.filter.service ? this.filter.service : null, // ไม่ require
          status: this.filter.status ? this.filter.status : null, // ไม่ require, status => Pending, Approved, Done, Cancel By Customer, Cancel By Admin
          customer: this.filter.customer ? this.filter.customer : null
        }
        api.getmjdappointmentsdshboard(data, (err, response) => {
          if (err) {
            reject(err)
          }
          if (response.data2) {
            response.data2 = response.data2.map((el) => {
              return {
                ...el,
                status:
                  el.status && el.status.toLowerCase().includes('cancel by admin')
                    ? 'Cancel By Admin'
                    : el.status
              }
            })
          }
          resolve(response)
        })
      })
    },
    showEditModal(item) {
      this.edittype = 'edit'
      this.editdata = item
      this.showEdit = true
    },
    showAddModal() {
      this.edittype = 'add'
      this.editdata = null
      this.showEdit = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/Appointment.vue